export const PRESET_BOUNDS = {
  'Middle East': [
    [35.1, 33.0], // southwest (lng, lat)
    [36.6, 34.7], // northeast (lng, lat)
  ],
};

export const FIT_OPTIONS = {
  padding: { top: 40, right: 40, bottom: 40, left: 40 },
  duration: 1200,
  essential: true,
  pitch: 0,
  bearing: 0,
};
